import React from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtnGroup,
} from "mdb-react-ui-kit";
import "./AccountLinkModal.css";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

export class AccountLinkModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      existingLink: null,                 // link object if already linked
      selectedPersonalId: null,           // selected personal account ID
      modo: "RESUMIDO",                   // RESUMIDO | DETALLADO
      loaded: false,
    };
  }

  componentDidMount() {
    this.loadExistingLink();
  }

  loadExistingLink() {
    const { cuenta } = this.props;
    if (!cuenta) return;

    this.props.onLoading(true);

    doFetch("CCON", `getLinkedAccounts?IDCuenta=${cuenta.IDCuenta}`, null)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          const existing = data.DATA.linksAsShared && data.DATA.linksAsShared[0]
            ? data.DATA.linksAsShared[0]
            : null;
          this.setState({
            existingLink: existing,
            modo: existing ? existing.Modo : "RESUMIDO",
            loaded: true,
          });
        } else {
          this.setState({ loaded: true });
        }
      })
      .catch(() => this.setState({ loaded: true }))
      .finally(() => this.props.onLoading(false));
  }

  handleLink() {
    const { cuenta } = this.props;
    const { selectedPersonalId, modo } = this.state;
    if (!selectedPersonalId) return;

    this.props.onLoading(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        IDCuentaGastos: cuenta.IDCuenta,
        IDCuentaPersonal: selectedPersonalId,
        Modo: modo,
      }),
    };

    doFetch("CCON", "linkSharedToPersonal", requestOptions)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.props.onClose(true);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => this.props.onLoading(false));
  }

  handleUnlink() {
    const { cuenta } = this.props;

    this.props.onLoading(true);

    const requestOptions = {
      method: "DELETE",
    };

    doFetch("CCON", `unlinkSharedFromPersonal?IDCuentaGastos=${cuenta.IDCuenta}`, requestOptions)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.props.onClose(true);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => this.props.onLoading(false));
  }

  handleUpdateMode(nuevoModo) {
    const { existingLink } = this.state;
    if (!existingLink) return;

    this.props.onLoading(true);

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        IDCuentaAsociada: existingLink.IDCuentaAsociada,
        Modo: nuevoModo,
      }),
    };

    doFetch("CCON", "updateLinkMode", requestOptions)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.setState({ existingLink: { ...existingLink, Modo: nuevoModo }, modo: nuevoModo });
        }
      })
      .catch((err) => console.error(err))
      .finally(() => this.props.onLoading(false));
  }

  render() {
    const { cuenta, cuentasPersonales } = this.props;
    const { existingLink, selectedPersonalId, modo, loaded } = this.state;

    const personalOptions = (cuentasPersonales || []).map((c) => ({
      text: c.nombre,
      value: c.IDCuenta,
    }));

    return (
      <MDBModal show={true} onHide={() => this.props.onClose(false)} tabIndex="-1">
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                Asociar cuenta de gastos compartidos
              </MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => this.props.onClose(false)} />
            </MDBModalHeader>
            <MDBModalBody>
              {!loaded ? (
                <p>Cargando...</p>
              ) : existingLink ? (
                <>
                  <div className="account-link-modal-existing">
                    <div className="link-label">Vinculada a cuenta personal:</div>
                    <div className="link-value">{existingLink.nombreCuentaPersonal || `ID ${existingLink.IDCuentaPersonal}`}</div>
                    <div className="link-label mt-2">Modo actual:</div>
                    <div className="link-value">{existingLink.Modo}</div>
                  </div>

                  <p className="mb-1">Cambiar modo de visualización:</p>
                  <MDBBtnGroup className="account-link-modal-mode-group">
                    <MDBBtn
                      color={modo === "RESUMIDO" ? "primary" : "light"}
                      onClick={() => this.handleUpdateMode("RESUMIDO")}
                    >
                      Resumen
                    </MDBBtn>
                    <MDBBtn
                      color={modo === "DETALLADO" ? "primary" : "light"}
                      onClick={() => this.handleUpdateMode("DETALLADO")}
                    >
                      Detallado
                    </MDBBtn>
                  </MDBBtnGroup>
                </>
              ) : (
                <>
                  <p>
                    Selecciona la cuenta personal donde se reflejarán tus gastos proporcionales de <strong>{cuenta.nombre}</strong>:
                  </p>
                  <select
                    className="form-select"
                    value={selectedPersonalId ?? ""}
                    onChange={(e) =>
                      this.setState({ selectedPersonalId: e.target.value ? Number(e.target.value) : null })
                    }
                  >
                    <option value="">— Selecciona una cuenta —</option>
                    {personalOptions.map((o) => (
                      <option key={o.value} value={o.value}>{o.text}</option>
                    ))}
                  </select>
                  <p className="mt-3 mb-1">Modo de visualización:</p>
                  <MDBBtnGroup className="account-link-modal-mode-group">
                    <MDBBtn
                      color={modo === "RESUMIDO" ? "primary" : "light"}
                      onClick={() => this.setState({ modo: "RESUMIDO" })}
                    >
                      Resumen
                    </MDBBtn>
                    <MDBBtn
                      color={modo === "DETALLADO" ? "primary" : "light"}
                      onClick={() => this.setState({ modo: "DETALLADO" })}
                    >
                      Detallado
                    </MDBBtn>
                  </MDBBtnGroup>
                  <p className="text-muted mt-2" style={{ fontSize: "0.8rem" }}>
                    <strong>Resumen:</strong> añade una sola línea con tu total proporcional.<br />
                    <strong>Detallado:</strong> añade cada transacción proporcionalmente.
                  </p>
                </>
              )}
            </MDBModalBody>
            <MDBModalFooter>
              {existingLink && (
                <MDBBtn color="danger" outline onClick={() => this.handleUnlink()}>
                  Desenlazar
                </MDBBtn>
              )}
              <MDBBtn color="secondary" onClick={() => this.props.onClose(false)}>
                Cancelar
              </MDBBtn>
              {!existingLink && (
                <MDBBtn
                  disabled={!selectedPersonalId}
                  onClick={() => this.handleLink()}
                >
                  Enlazar
                </MDBBtn>
              )}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }
}
